import { initializeApp } from 'firebase/app'
import { getMessaging, isSupported } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyD-OJhGtCXtZnT9M4UrhxiyUJI58LBQI2s',
  authDomain: 'ggram-545c5.firebaseapp.com',
  projectId: 'ggram-545c5',
  storageBucket: 'ggram-545c5.firebasestorage.app',
  messagingSenderId: '921520579373',
  appId: '1:921520579373:web:6da8ef19dafab975bd69a4',
  measurementId: 'G-DGBN5VPXCL',
}

export const firebaseApp = initializeApp(firebaseConfig)

// Lazy: не инициализируем при загрузке модуля — Firebase Messaging может
// бросить исключение в несовместимых браузерах (Firefox без push, Safari <16.4)
let _messaging: ReturnType<typeof getMessaging> | null = null

export async function getMessagingInstance() {
  if (_messaging) return _messaging
  try {
    const supported = await isSupported()
    if (!supported) return null
    _messaging = getMessaging(firebaseApp)
    return _messaging
  } catch {
    return null
  }
}

export const VAPID_KEY =
  'BI1Mpjk-vdGmv52GrBRjxDqYm1STC3BfozJfua30lyCVs3Wppv7FSN-t_K9eGPyFx88KvJcRm8vXjpdgrP6tu1o'
